<template>
  <footer id="footer" class="modern-footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <!-- 公司简介 -->
          <div class="col-md-4 footer-col">
            <div class="footer-brand">
              <a
                href="javascript:;"
                @click="goToPage('/home', 0)"
                class="brand-link"
              >
                <h3 class="brand-name">利达建安</h3>
              </a>
              <p class="brand-desc">
                广东利达建安装饰工程有限公司，拥有建筑装修装饰工程专业承包二级、建筑机电安装工程专业承包二级。
              </p>
              <div class="social-links">
                <router-link
                  to="/contactus"
                  class="social-item"
                  title="联系电话"
                  ><i class="el-icon-phone"></i
                ></router-link>
                <router-link
                  to="/contactus"
                  class="social-item"
                  title="在线咨询"
                  ><i class="el-icon-chat-dot-round"></i
                ></router-link>
                <router-link
                  to="/contactus"
                  class="social-item"
                  title="公司地址"
                  ><i class="el-icon-location-outline"></i
                ></router-link>
              </div>
            </div>
          </div>

          <!-- 快速链接 -->
          <div class="col-md-2 footer-col">
            <h4 class="footer-title">快速链接</h4>
            <ul class="footer-links">
              <li>
                <a href="javascript:;" @click="goToPage('/home', 0)"
                  >首页展示</a
                >
              </li>
              <li><router-link to="/newsinformation">关于我们</router-link></li>
              <li><router-link to="/case">精选案例</router-link></li>
              <li><router-link to="/contactus">联系我们</router-link></li>
            </ul>
          </div>

          <!-- 业务范畴 -->
          <div class="col-md-3 footer-col">
            <h4 class="footer-title">业务范畴</h4>
            <ul class="footer-links">
              <li>
                <router-link to="/case?catId=0">办公空间装饰</router-link>
              </li>
              <li>
                <router-link to="/case?catId=2">净化暖通工程</router-link>
              </li>
              <li>
                <router-link to="/case?catId=1">机电安装工程</router-link>
              </li>
              <li><router-link to="/case?type=4">工业厂房建设</router-link></li>
            </ul>
          </div>

          <!-- 联系方式 -->
          <div class="col-md-3 footer-col">
            <h4 class="footer-title">联系我们</h4>
            <div class="contact-info">
              <div class="contact-item">
                <i class="el-icon-location"></i>
                <p>深圳市光明区光明大道380号尚智科技园1栋B座19楼</p>
              </div>
              <div class="contact-item">
                <i class="el-icon-phone-outline"></i>
                <p>0755-27822259 / 18603072366</p>
              </div>
              <div class="contact-item">
                <i class="el-icon-message"></i>
                <p>ldja@example.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部版权 -->
    <div class="footer-bottom">
      <div class="container">
        <div class="bottom-flex">
          <p class="copy-text">
            广东利达建安装饰工程有限公司
            <a href="https://beian.miit.gov.cn/" target="_blank"
              >&copy; 备案号：粤ICP备2022089272号</a
            >
          </p>
          <div class="bottom-links">
            <a href="javascript:;">隐私政策</a>
            <span class="sep">|</span>
            <a href="javascript:;">法律声明</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    goToPage(path, sectionIndex) {
      if (
        this.$route.path === path ||
        (path === "/home" && this.$route.path === "/")
      ) {
        // 如果已在目标页面，触发滚动到顶部
        window.dispatchEvent(
          new CustomEvent("scroll-to-section", { detail: sectionIndex || 0 })
        );
      } else {
        // 否则进行路由跳转
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.modern-footer {
  background-color: #1a1a1a;
  color: #fff;
  padding-top: 80px;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.footer-top {
  padding-bottom: 60px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-col {
  margin-bottom: 40px;
}

.footer-brand .brand-name {
  color: #1577c2;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}

.brand-link {
  text-decoration: none;
  display: inline-block;
}

.brand-link:hover .brand-name {
  opacity: 0.8;
}

.brand-desc {
  color: #999;
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: 30px;
}

.footer-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 30px;
  position: relative;
  padding-bottom: 12px;
}

.footer-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 2px;
  background-color: #1577c2;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 15px;
}

.footer-links a {
  color: #999;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s;
}

.footer-links a:hover {
  color: #1577c2;
  padding-left: 8px;
}

.contact-info .contact-item {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.contact-info i {
  color: #1577c2;
  font-size: 20px;
  margin-top: 2px;
}

.contact-info p {
  color: #999;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

.social-links {
  display: flex;
  gap: 15px;
}

.social-item {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-decoration: none;
  transition: all 0.3s;
}

.social-item:hover {
  background: #1577c2;
  transform: translateY(-3px);
}

.footer-bottom {
  padding: 30px 0;
  background-color: #151515;
}

.bottom-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.copy-text {
  color: #666;
  font-size: 13px;
  margin: 0;
}

.copy-text a {
  color: #666;
  text-decoration: none;
  margin-left: 10px;
}

.copy-text a:hover {
  color: #999;
}

.bottom-links {
  display: flex;
  align-items: center;
  gap: 15px;
}

.bottom-links a {
  color: #666;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.3s;
}

.bottom-links a:hover {
  color: #999;
}

.sep {
  color: #333;
}

@media (max-width: 768px) {
  .modern-footer {
    padding-top: 50px;
  }
  .bottom-flex {
    flex-direction: column;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue